import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync, faEdit, faEye } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ClientesData.css';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import moneda from '../../moneda';
import { adminFetch } from '../../../utils/api';

export default function ClientesData() {
    const [clientes, setClientes] = useState([]);
    const [tipos, setTipos] = useState([]);
    const [buscar, setBuscar] = useState('');
    const [filtroTipo, setFiltroTipo] = useState('');
    const [pagina, setPagina] = useState(1);
    const [totalPaginas, setTotalPaginas] = useState(1);

    // Modal pedidos (lista)
    const [modalPedidos, setModalPedidos] = useState(false);
    const [clienteActivo, setClienteActivo] = useState(null);
    const [pedidosCliente, setPedidosCliente] = useState([]);
    const [cargandoPedidos, setCargandoPedidos] = useState(false);

    // Modal detalle (reutiliza PedidosData)
    const [modalDetalle, setModalDetalle] = useState(false);
    const [pedido, setPedido] = useState({});
    const [nuevoEstado, setNuevoEstado] = useState('');

    useEffect(() => { cargarTipos(); }, []);
    useEffect(() => { cargarClientes(); }, [buscar, filtroTipo, pagina]);

    const cargarTipos = () => {
        adminFetch(`${baseURL}/api/admin/tipos-cliente`, { method: 'GET' })
            .then(r => r.json())
            .then(data => setTipos(data.tipos || []))
            .catch(() => {});
    };

    const cargarClientes = () => {
        const params = new URLSearchParams();
        if (buscar) params.append('buscar', buscar);
        if (filtroTipo) params.append('idTipoCliente', filtroTipo);
        params.append('pagina', pagina);
        adminFetch(`${baseURL}/api/admin/clientes?${params}`, { method: 'GET' })
            .then(r => r.json())
            .then(data => {
                setClientes(data.clientes || []);
                setTotalPaginas(data.paginas || 1);
            })
            .catch(() => {});
    };

    const verPedidos = (cliente) => {
        setClienteActivo(cliente);
        setPedidosCliente([]);
        setModalPedidos(true);
        setCargandoPedidos(true);
        adminFetch(`${baseURL}/api/admin/pedidos/cliente/${cliente.idCliente}`)
            .then(r => r.json())
            .then(data => setPedidosCliente(data.pedidos || []))
            .catch(() => {})
            .finally(() => setCargandoPedidos(false));
    };

    const abrirDetalle = (item) => {
        setPedido(item);
        setNuevoEstado(item.estado);
        setModalDetalle(true);
    };

    const guardarEstado = () => {
        adminFetch(`${baseURL}/api/admin/pedidos/${pedido.idPedido}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ estado: nuevoEstado }),
        })
            .then(r => r.json())
            .then(data => {
                if (data.error) {
                    Swal.fire('Error', data.error, 'error');
                } else {
                    Swal.fire('Guardado', data.mensaje, 'success');
                    setModalDetalle(false);
                    // Refrescar lista de pedidos del cliente
                    adminFetch(`${baseURL}/api/admin/pedidos/cliente/${clienteActivo.idCliente}`)
                        .then(r => r.json())
                        .then(d => setPedidosCliente(d.pedidos || []))
                        .catch(() => {});
                }
            })
            .catch(() => toast.error('Error de conexión'));
    };

    const editarCliente = (cliente) => {
        const opcionesTipo = tipos
            .map(t => `<option value="${t.idTipoCliente}" ${cliente.tipoCliente === t.nombre ? 'selected' : ''}>${t.nombre}</option>`)
            .join('');

        Swal.fire({
            title: 'Editar cliente',
            width: 480,
            html: `
                <div style="text-align:left;display:flex;flex-direction:column;gap:10px;padding:4px 0">
                    <div>
                        <label style="font-size:12px;color:#888;display:block;margin-bottom:3px">Nombre</label>
                        <input id="swal-nombre" class="swal2-input" style="margin:0;width:100%;box-sizing:border-box"
                            placeholder="Nombre completo" value="${cliente.nombre || ''}">
                    </div>
                    <div>
                        <label style="font-size:12px;color:#888;display:block;margin-bottom:3px">Teléfono</label>
                        <input id="swal-telefono" class="swal2-input" style="margin:0;width:100%;box-sizing:border-box"
                            placeholder="Teléfono" value="${cliente.telefono || ''}">
                    </div>
                    <div>
                        <label style="font-size:12px;color:#888;display:block;margin-bottom:3px">Email</label>
                        <input id="swal-email" type="email" class="swal2-input" style="margin:0;width:100%;box-sizing:border-box"
                            placeholder="Email (opcional)" value="${cliente.email || ''}">
                    </div>
                    <div>
                        <label style="font-size:12px;color:#888;display:block;margin-bottom:3px">Tipo de cliente</label>
                        <select id="swal-tipo" class="swal2-input" style="margin:0;width:100%;box-sizing:border-box;height:42px">
                            ${opcionesTipo}
                        </select>
                    </div>
                    <hr style="border:none;border-top:1px solid #eee;margin:4px 0">
                    <div>
                        <label style="font-size:12px;color:#888;display:block;margin-bottom:3px">Nueva contraseña <span style="color:#bbb">(dejar vacío para no cambiar)</span></label>
                        <input id="swal-pass" type="password" class="swal2-input" style="margin:0;width:100%;box-sizing:border-box"
                            placeholder="Mín. 6 caracteres" minlength="6">
                    </div>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Guardar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#3085d6',
            focusConfirm: false,
            preConfirm: () => {
                const nombre   = document.getElementById('swal-nombre').value.trim();
                const telefono = document.getElementById('swal-telefono').value.trim();
                const email    = document.getElementById('swal-email').value.trim();
                const tipo     = document.getElementById('swal-tipo').value;
                const pass     = document.getElementById('swal-pass').value;
                if (!nombre)             { Swal.showValidationMessage('El nombre es requerido'); return false; }
                if (!telefono)           { Swal.showValidationMessage('El teléfono es requerido'); return false; }
                if (pass && pass.length < 6) { Swal.showValidationMessage('La contraseña debe tener al menos 6 caracteres'); return false; }
                return { nombre, telefono, email, idTipoCliente: parseInt(tipo), contrasena: pass || undefined };
            },
        }).then(result => {
            if (!result.isConfirmed) return;
            const body = { ...result.value };
            if (!body.contrasena) delete body.contrasena;
            adminFetch(`${baseURL}/api/admin/clientes/${cliente.idCliente}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body),
            })
                .then(r => r.json())
                .then(data => {
                    if (data.mensaje) { toast.success('Cliente actualizado'); cargarClientes(); }
                    else { Swal.fire('Error', data.error || 'No se pudo actualizar', 'error'); }
                })
                .catch(() => Swal.fire('Error', 'Error de conexión', 'error'));
        });
    };

    const estadoColor = (estado) => {
        const mapa = { Pendiente: '#DAA520', Entregado: '#0000FF', Rechazado: '#FF0000', Pagado: '#008000' };
        return mapa[estado] || '#000';
    };

    return (
        <div>
            <ToastContainer />

            <div className='deFlexContent'>
                <div className='deFlex2' />
                <div className='filtrosContain'>
                    <div className='inputsColumn'>
                        <input
                            type="text"
                            placeholder="Nombre, teléfono o email"
                            value={buscar}
                            onChange={e => { setBuscar(e.target.value); setPagina(1); }}
                        />
                    </div>
                    <div className='inputsColumn'>
                        <select value={filtroTipo} onChange={e => { setFiltroTipo(e.target.value); setPagina(1); }}>
                            <option value="">Todos los tipos</option>
                            {tipos.map(t => (
                                <option key={t.idTipoCliente} value={t.idTipoCliente}>{t.nombre}</option>
                            ))}
                        </select>
                    </div>
                    <button className='reload' onClick={cargarClientes}><FontAwesomeIcon icon={faSync} /></button>
                </div>
            </div>

            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Teléfono</th>
                            <th>Nombre</th>
                            <th>Email</th>
                            <th>Tipo</th>
                            <th>Pedidos</th>
                            <th>Registro</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {clientes.length === 0 ? (
                            <tr><td colSpan={8} style={{ textAlign: 'center', padding: 20 }}>Sin resultados</td></tr>
                        ) : clientes.map(c => (
                            <tr key={c.idCliente}>
                                <td data-label="ID">{c.idCliente}</td>
                                <td data-label="Teléfono">{c.telefono}</td>
                                <td data-label="Nombre">{c.nombre || '—'}</td>
                                <td data-label="Email">{c.email || '—'}</td>
                                <td data-label="Tipo">{c.tipoCliente || '—'}</td>
                                <td data-label="Pedidos" style={{ textAlign: 'center' }}>
                                    <button className='btn-ver' onClick={() => verPedidos(c)} title="Ver pedidos">
                                        <FontAwesomeIcon icon={faEye} />
                                        {c.totalPedidos > 0 && <span style={{ fontSize: 11, marginLeft: 4 }}>{c.totalPedidos}</span>}
                                    </button>
                                </td>
                                <td data-label="Registro">{c.createdAt?.split('T')[0] || c.createdAt}</td>
                                <td data-label="Acciones" className="td-acciones">
                                    <div className="acciones-container">
                                        <button className='btn-editar' onClick={() => editarCliente(c)} title="Editar cliente">
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {totalPaginas > 1 && (
                <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 12 }}>
                    <button disabled={pagina === 1} onClick={() => setPagina(p => p - 1)} className='reload'>‹</button>
                    <span style={{ padding: '6px 10px' }}>{pagina} / {totalPaginas}</span>
                    <button disabled={pagina === totalPaginas} onClick={() => setPagina(p => p + 1)} className='reload'>›</button>
                </div>
            )}

            {/* ── MODAL LISTA DE PEDIDOS ── */}
            {modalPedidos && (
                <div className="modal" onClick={e => e.target === e.currentTarget && setModalPedidos(false)}>
                    <div className="modal-content" style={{ maxWidth: 700 }}>
                        <div className='deFlexBtnsModal'>
                            <h3 style={{ margin: 0, fontSize: 15 }}>
                                Pedidos de {clienteActivo?.nombre || clienteActivo?.telefono}
                            </h3>
                            <span className="close" onClick={() => setModalPedidos(false)}>&times;</span>
                        </div>

                        {cargandoPedidos ? (
                            <p style={{ padding: 20, textAlign: 'center' }}>Cargando...</p>
                        ) : pedidosCliente.length === 0 ? (
                            <p style={{ padding: 20, textAlign: 'center', color: '#888' }}>Este cliente no tiene pedidos registrados.</p>
                        ) : (
                            <div className='table-container' style={{ maxHeight: 420, overflowY: 'auto' }}>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Estado</th>
                                            <th>Entrega</th>
                                            <th>Pago</th>
                                            <th>Total</th>
                                            <th>Fecha</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pedidosCliente.map(p => (
                                            <tr key={p.idPedido} onClick={() => abrirDetalle(p)} style={{ cursor: 'pointer' }} title="Ver detalle">
                                                <td data-label="#">{p.idPedido}</td>
                                                <td data-label="Estado" style={{ color: estadoColor(p.estado), fontWeight: 600 }}>{p.estado}</td>
                                                <td data-label="Entrega">{p.entrega}</td>
                                                <td data-label="Pago">{p.pago}</td>
                                                <td data-label="Total" style={{ color: '#008000', fontWeight: 600 }}>{moneda} {p.total}</td>
                                                <td data-label="Fecha">{p.createdAt?.split('T')[0] || p.createdAt}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* ── MODAL DETALLE PEDIDO (reutiliza PedidosData) ── */}
            {modalDetalle && (
                <div className="modal" onClick={e => e.target === e.currentTarget && setModalDetalle(false)}>
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <span style={{ fontWeight: 600, fontSize: 14 }}>Pedido #{pedido.idPedido}</span>
                            <span className="close" onClick={() => setModalDetalle(false)}>&times;</span>
                        </div>
                        <div className='sectiontext' style={{ display: 'flex' }}>
                            <div className='flexGrap'>
                                <fieldset><legend>ID Pedido</legend><input value={pedido.idPedido} disabled /></fieldset>
                                <fieldset><legend>Nombre</legend><input value={pedido.nombre} disabled /></fieldset>
                                <fieldset><legend>Email</legend><input value={pedido.email || ''} disabled /></fieldset>
                                <fieldset><legend>Teléfono</legend><input value={pedido.telefono} disabled /></fieldset>
                                <fieldset><legend>Pago</legend><input value={pedido.pago} disabled /></fieldset>
                                <fieldset><legend>Entrega</legend><input value={pedido.entrega} disabled /></fieldset>
                                <fieldset><legend>Código</legend><input value={pedido.codigo} disabled /></fieldset>
                                <fieldset><legend>Nota</legend><input value={pedido.nota} disabled /></fieldset>
                                <fieldset><legend>Fecha</legend><input value={pedido.createdAt} disabled /></fieldset>
                                <fieldset><legend>Total</legend><input value={`${moneda} ${pedido.total}`} disabled /></fieldset>
                                <fieldset>
                                    <legend>Estado</legend>
                                    <select value={nuevoEstado} onChange={e => setNuevoEstado(e.target.value)}>
                                        <option value="Pendiente">Pendiente</option>
                                        <option value="Pagado">Pagado</option>
                                        <option value="Entregado">Entregado</option>
                                        <option value="Rechazado">Rechazado</option>
                                    </select>
                                </fieldset>
                            </div>
                            <div className='cardsProductData'>
                                {(() => {
                                    try {
                                        const prods = typeof pedido.productos === 'string'
                                            ? JSON.parse(pedido.productos)
                                            : pedido.productos;
                                        return prods.map((producto, i) => (
                                            <div key={i} className='cardProductData'>
                                                <img src={producto.imagen} alt="imagen" />
                                                <div className='cardProductDataText'>
                                                    <h3>{producto.titulo}</h3>
                                                    <strong>{moneda} {producto.precio} <span>x{producto.cantidad}</span></strong>
                                                    <span>{producto.item}</span>
                                                </div>
                                            </div>
                                        ));
                                    } catch { return null; }
                                })()}
                            </div>
                            <button className='btnPost' onClick={guardarEstado}>Guardar</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
